import React, {
    useEffect,
    useRef,
    useState,
} from "react";

import HomeBanner from "../components/home-banner/HomeBanner";
import FeatureInfo from "../components/FeatureInfo";
import CourseCategoryList from "../components/course/CourseCategoryList";
import PackageList from "../components/PackageList";
import WelcomeSection from "../components/WelcomeSection";
import StatisticsSection from "../components/StatisticsSection";
import Testimonials from "../components/Testimonials";
import Header from "../components/Header";

import { dashboard } from "../handler/LoginAndSingupHandler";

import UserLoaderVideo from "../Dashboard/UserLoaderVideo";

import banner from "../Photos/Banner/HomeBanner.png";

import { NativeBiometric } from "capacitor-native-biometric";
import { Capacitor } from "@capacitor/core";


const HomePage = () => {

    /* ============================================================
       LOADER
    ============================================================ */

    const [loader, setLoader] = useState(true);


    /* ============================================================
       STATISTICS
    ============================================================ */

    const [statistics, setStatistics] = useState({
        students: 0,
        courses: 0,
        teachers: 0,
        awards: 0,
    });


    /* ============================================================
       RUN ONCE
    ============================================================ */

    const runOnce = useRef(false);


    /* ============================================================
       BANNER
    ============================================================ */

    const [showBanner, setShowBanner] = useState(true);


    /* ============================================================
       DASHBOARD API
    ============================================================ */

    const dashboardApi = async () => {

        try {

            const response = await dashboard();

            if (response.statusCode === 200) {

                setStatistics(
                    response.data.dashboard.statistics
                );

            }

        } catch (error) {

            console.error(
                "Dashboard API error:",
                error
            );

        }

        setTimeout(() => {

            setLoader(false);

        }, 3000);
    };


    /* ============================================================
       INITIAL LOAD
    ============================================================ */

    useEffect(() => {

        if (runOnce.current === false) {

            dashboardApi();

            runOnce.current = true;

        }

    }, []);


    /* ============================================================
       BIOMETRIC LOGIN
    ============================================================ */

    const loginWithBiometric = async () => {

        try {

            setLoader(true);

            await NativeBiometric.verifyIdentity({

                reason: "Log in securely",

                title: "Biometric Login",

                subtitle:
                    "Use fingerprint, face, or device PIN",

                description:
                    "Authenticate to access your account",

                useFallback: true,

            });

            window.location.href = "/mycourses";

        } catch (err) {

            console.error(
                "Authentication failed",
                err
            );

            setLoader(false);

        }

        setLoader(false);
    };


    /* ============================================================
       ANDROID BIOMETRIC
    ============================================================ */

    useEffect(() => {

        if (
            Capacitor.getPlatform() ===
            "android"
        ) {

            setLoader(true);

            const appKey =
                localStorage.getItem(
                    "appkey"
                );

            if (appKey !== null) {

                loginWithBiometric();

            }

            setLoader(false);
        }

    }, []);


    /* ============================================================
       LOADER
    ============================================================ */

    if (loader) {

        return <UserLoaderVideo />;

    }


    /* ============================================================
       PAGE
    ============================================================ */

    return (

        <>

            {/* ====================================================
                GLOBAL FUTURISTIC PAGE STYLE
            ==================================================== */}

            <style>
                {`

                /* ==================================================
                   GLOBAL RESET
                ================================================== */

                html,
                body,
                #root {

                    margin: 0 !important;

                    padding: 0 !important;

                    width: 100%;

                    min-height: 100%;

                    background: #02070d !important;

                }


                body {

                    overflow-x: hidden;

                    color: #ffffff;

                }


                /* ==================================================
                   MAIN PAGE
                ================================================== */

                .growniverse-home-page {

                    position: relative;

                    width: 100%;

                    min-height: 100vh;

                    margin: 0;

                    padding: 0;

                    overflow-x: hidden;

                    background:

                        radial-gradient(
                            circle at 10% 10%,
                            rgba(0, 217, 255, 0.08),
                            transparent 28%
                        ),

                        radial-gradient(
                            circle at 90% 20%,
                            rgba(82, 108, 255, 0.08),
                            transparent 30%
                        ),

                        radial-gradient(
                            circle at 50% 90%,
                            rgba(0, 217, 255, 0.05),
                            transparent 35%
                        ),

                        linear-gradient(
                            180deg,
                            #02070d 0%,
                            #030a11 35%,
                            #02070d 70%,
                            #01050a 100%
                        );

                }


                /* ==================================================
                   FUTURISTIC BACKGROUND GRID
                ================================================== */

                .growniverse-page-grid {

                    position: fixed;

                    inset: 0;

                    width: 100%;

                    height: 100%;

                    pointer-events: none;

                    z-index: 0;

                    opacity: 0.20;

                    background-image:

                        linear-gradient(
                            rgba(0, 210, 255, 0.055) 1px,
                            transparent 1px
                        ),

                        linear-gradient(
                            90deg,
                            rgba(0, 210, 255, 0.055) 1px,
                            transparent 1px
                        );

                    background-size:
                        55px 55px;

                    mask-image:

                        linear-gradient(
                            to bottom,
                            transparent 0%,
                            black 12%,
                            black 85%,
                            transparent 100%
                        );

                }


                /* ==================================================
                   CYAN GLOW
                ================================================== */

                .growniverse-page-glow {

                    position: fixed;

                    width: 500px;

                    height: 500px;

                    border-radius: 50%;

                    pointer-events: none;

                    z-index: 0;

                    filter: blur(100px);

                    opacity: 0.08;

                }


                .growniverse-page-glow-one {

                    top: 120px;

                    left: -250px;

                    background:
                        #00d9ff;

                }


                .growniverse-page-glow-two {

                    top: 600px;

                    right: -250px;

                    background:
                        #526cff;

                }


                .growniverse-page-glow-three {

                    bottom: -300px;

                    left: 35%;

                    background:
                        #00d9ff;

                }


                /* ==================================================
                   CONTENT LAYER
                ================================================== */

                .growniverse-home-content {

                    position: relative;

                    z-index: 2;

                    width: 100%;

                    min-height: 100vh;

                    margin: 0;

                    padding: 0;

                    background: transparent;

                }


                /* ==================================================
                   HEADER FIXED AT TOP
                ================================================== */

                .growniverse-home-content
                .growniverse-header {

                    position: fixed !important;

                    top: 0 !important;

                    left: 0 !important;

                    right: 0 !important;

                    width: 100% !important;

                    margin: 0 !important;

                    z-index: 99999 !important;

                }


                /* ==================================================
                   SPACE FOR FIXED HEADER
                   
                   Prevents HomeBanner from going underneath
                   the fixed header.
                ================================================== */

                .growniverse-home-header-space {

                    height: 88px;

                    width: 100%;

                }


                /* ==================================================
                   SECTIONS TRANSPARENT
                   
                   This prevents white blocks between sections.
                ================================================== */

                .growniverse-home-content
                section {

                    background-color:
                        transparent;

                }


                /* ==================================================
                   COMMON FUTURISTIC SECTION EFFECT
                ================================================== */

                .growniverse-home-content
                > section:not(
                    .growniverse-home-banner-section
                ) {

                    position: relative;

                }


                /* ==================================================
                   MOBILE
                ================================================== */

                @media (max-width: 768px) {

                    .growniverse-home-header-space {

                        height: 86px;

                    }

                }


                @media (max-width: 420px) {

                    .growniverse-home-header-space {

                        height: 80px;

                    }

                }

                `}
            </style>


            {/* ====================================================
                MAIN FUTURISTIC PAGE
            ==================================================== */}

            <div
                className="growniverse-home-page"
            >


                {/* ==================================================
                    BACKGROUND GRID
                ================================================== */}

                <div
                    className="
                        growniverse-page-grid
                    "
                />


                {/* ==================================================
                    BACKGROUND GLOWS
                ================================================== */}

                <div
                    className="
                        growniverse-page-glow
                        growniverse-page-glow-one
                    "
                />

                <div
                    className="
                        growniverse-page-glow
                        growniverse-page-glow-two
                    "
                />

                <div
                    className="
                        growniverse-page-glow
                        growniverse-page-glow-three
                    "
                />


                {/* ==================================================
                    CONTENT
                ================================================== */}

                <div
                    className="
                        growniverse-home-content
                    "
                >


                    {/* ==================================================
                        HEADER
                    ================================================== */}

                    <Header />


                    {/* ==================================================
                        HEADER SPACE
                    ================================================== */}

                    <div
                        className="
                            growniverse-home-header-space
                        "
                    />


                    {/* ==================================================
                        HOME BANNER
                    ================================================== */}

                    <div
                        className="
                            growniverse-home-banner-section
                        "
                    >

                        <HomeBanner />

                    </div>


                    {/* ==================================================
                        FEATURE INFO
                    ================================================== */}

                    <FeatureInfo />


                    {/* ==================================================
                        WELCOME
                    ================================================== */}

                    <WelcomeSection />


                    {/* ==================================================
                        COURSE CATEGORIES
                    ================================================== */}

                    <CourseCategoryList />


                    {/* ==================================================
                        STATISTICS
                    ================================================== */}

                    <StatisticsSection
                        statistics={{
                            students:
                                statistics.students +
                                1000,

                            courses:
                                statistics.courses,

                            teachers:
                                statistics.teachers,

                            awards:
                                statistics.awards,
                        }}
                    />


                    {/* ==================================================
                        PACKAGES
                    ================================================== */}

                    <PackageList />


                    {/* ==================================================
                        TESTIMONIALS
                    ================================================== */}

                    <Testimonials />


                </div>


                {/* ====================================================
                    POPUP BANNER
                ==================================================== */}

                {showBanner && (

                    <section
                        onClick={() =>
                            setShowBanner(false)
                        }
                    >

                        <div
                            style={{
                                background:
                                    "rgba(0, 0, 0, 0.5)",

                                position:
                                    "fixed",

                                height: "100%",

                                width: "100%",

                                left: "0",

                                top: "0",

                                zIndex: 100000,
                            }}
                        >

                            <img
                                src={banner}
                                className="banner"
                                alt="Growniverse Banner"
                            />

                        </div>

                    </section>

                )}

            </div>

        </>

    );
};


export default HomePage;